module.exports = __webpack_public_path__ + "img/Groupe 81.c3b7722c.svg";